import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import AdminPage from './pages/AdminPage';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

export default App;
